
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import GlobalConfig from "@/GlobalConfig";
@Component({})
export default class SideBarC extends Vue {
  @Getter("displaySideBar") displaySideBar: boolean;
  public openCita: boolean = false;
  public verMas: boolean = false;
  public goActualizacionDatos() {
    this.$router.push("/actualizacion-de-datos");
  }

  public goEstadoCuenta() {
    this.$router.push("/tu-estado-cuenta");
  }
  public goSolicitudesBeneficios() {
    this.$router.push("/solicitudes-beneficiario");
  }
  public goDetallesCuenta() {
    this.$router.push("/consulta-tu-cuenta");
  }
  public goNotificacionBalance() {
    this.$router.push("/notificacion-balance");
  }
  public goReclamaciones() {
    this.$router.push("/solicitud-reclamaciones");
  }
  public goConsultaReclamaciones() {
    this.$router.push("/consulta-reclamaciones");
  }
  public goFallecidos() {
    this.$router.push("/consulta-afiliado-fallecido");
  }

  public goDashboard() {
    this.$router.push("/DashBoard");
  }
  isOptionActive(value: string) {
    if (this.$route.name == value) return true;
  }
  public goCitaSantoDomingo() {
    window.location.href =
      "https://outlook.office365.com/owa/calendar/SolicituddebeneficiosSantoDomingo@afpsiembra.com/bookings/";
  }
  public goCitaSantiago() {
    window.location.href =
      "https://outlook.office365.com/owa/calendar/SolicituddebeneficiosSucursalSantiago@afpsiembra.com/bookings/";
  }

public goCertificadoBeneficios(){
  this.$router.push("certificado-beneficios")
}
public goMiInversion(){
  this.$router.push("mi-inversion")
}
public goProyectaPension(){
  window.location.href = GlobalConfig.PORTAL_BASE_URL+'/calcula-tu-pension';
}
public goCalculaAportes(){
  window.location.href = GlobalConfig.PORTAL_BASE_URL+'/calculadora-de-aportes';
}
public goTipoEnvioEstadoCuenta(){
  this.$router.push("tipo-envio-estado-cuenta")
}
 
public goNotificacionAportes(){
  this.$router.push("notificacion-aportes")
}     
 @Watch("displaySideBar")
  OnDisplaySideBarChanged(value: boolean, oldValue: boolean) {
    const collection = document.getElementsByClassName(
      "SideBarItem"
    ) as HTMLCollectionOf<HTMLElement>;
    // console.log(value);
    for (let i = 0; i < collection.length; i++) {
      if (value) {
        collection[i].style.display = "flex";
      } else {
        collection[i].style.display = "none";
      }
    }
  }
}

function open() {
  document.getElementById("mySidebar").style.display = "block";
}

function close() {
  document.getElementById("mySidebar").style.display = "none";
}
function myFunction() {
  var x = document.getElementById("myDIV");
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}
document.querySelectorAll('[role="tooltip"]').forEach(function (el) {
  el.classList.remove("active");
});
